/**
 * The billing period is a fixed 3-letter month label (T-206). It used to be free
 * text, and a typo (SEPT -> SEPT2) defeated the (period, resource) idempotency
 * ledger and double-pushed bills. The year is not part of the label — see T-209.
 */
export const BILLING_PERIODS = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
] as const;

export type BillingPeriod = (typeof BILLING_PERIODS)[number];

export function isBillingPeriod(value: unknown): value is BillingPeriod {
  return typeof value === 'string' && (BILLING_PERIODS as readonly string[]).includes(value);
}

/**
 * Labels a month was recorded under before the 3-letter convention. Prod's
 * qb_bill_pushes holds SEPT rows, so a September push must still see them as
 * already pushed. Lookups use these; writes always use the canonical label.
 * Retire when T-209 re-keys the ledger on year + month.
 */
const LEGACY_PERIOD_LABELS: Readonly<Record<string, readonly string[]>> = {
  JUN: ['JUNE'],
  JUL: ['JULY'],
  SEP: ['SEPT'],
};

/** Every label that counts as this period when checking the push ledger. */
export function periodLedgerLabels(period: string): string[] {
  return [period, ...(LEGACY_PERIOD_LABELS[period] ?? [])];
}
